import WidgetContent from '@/internal-app/components/tasks/widgetContent'
import React from 'react'
import { connect } from 'react-redux'
import WidgetComponent from './widgetComponent'
import { Link } from 'react-router-dom'
import context from '@/context'
import Resx from '@/components/Resx'

function mapStateToProps (state) {
  return {
    changeNumber: state.myActiveTask.changeNumber
  }
}

@connect(mapStateToProps)
class TasksWidget extends WidgetComponent {
  componentKey () { return this.props.changeNumber }
  headerButtons () { return <Link to='/tasks'><Resx name='Common.More' /></Link> }
  widgetIcon () { return 'task' }
  widgetTitleKey () { return 'Tasks.TasksTitle' }
  dataSource () { return context.api.taskService.getMyTasks(addSorting(this._prepareDataSourceRequest(this.props.widgetItem))) }
  renderContent (data) { return <WidgetContent data={data.data} /> }
}
const addSorting = (request) => {
  if (!request) { request = {} }
  request.sort = [{ field: 'creationTime', dir: 'desc' }]
  request.filter = {
    logic: 'AND',
    filters: [
      { field: 'status', operator: 'neq', value: 2 }
    ]
  }

  return request
}
export {
  TasksWidget
}



// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/tasks.js